import React from "react";
import { createRoot } from "react-dom/client";

// import "@pankod/refine-antd/dist/reset.css";

import "react-quill/dist/quill.snow.css";
import "./styles/plotly.css";
import "./styles/quill.css";
import "./styles/modal.css";
import "./styles/table.css";
import "./styles/tabs.css";
import "./styles/sidebar.css";
import "./styles/input.css";

import reportWebVitals from "./reportWebVitals";
import App from "./App";
import { ConfigProvider } from "antd";
import { StagingAuthProvider } from "context/StagingAuthContext";

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "Titillium Web",
          colorPrimary: "#1A1D38",
          colorBgBase: "#1A1D38",
          colorTextBase: "#fff",
          colorIcon: "#fff",
          colorIconHover: "#f7f1f1",
          borderRadius: 6,
          colorBorder: "#6A6A6A",
          colorPrimaryBorder: "#6A6A6A",
          colorPrimaryBg: "#112212",
          colorTextDescription: "#fff"
        },
        components: {
          Modal: {
            colorBgBase: "#fff",
            colorPrimaryBg: "#fff",
            colorPrimary: "#fff",
            colorBgContainer: "#fff",
            colorBgBlur: "#fff",
            colorBgLayout: "#fff",
            contentBg: "#fff",
            colorText: "#000"
          },
          Input: {
            activeBorderColor: "#6A6A6A",
            hoverBorderColor: "#6A6A6A",
            colorBorder: "#6A6A6A",
            boxShadow: "none",
            boxShadowSecondary: "none",
            boxShadowTertiary: "none",
            activeShadow: "none",
            colorBgContainer: "#fff",
            colorTextPlaceholder: "#000",
            colorText: "#000"
          },
          InputNumber: {
            activeBorderColor: "#6A6A6A",
            hoverBorderColor: "#6A6A6A",
            colorBgBase: "#fff",
            activeBg: "#fff",
            addonBg: "#fff",
            colorBgContainer: "#fff",
            colorText: "#fff",
            colorTextDescription: "#000"
          },
          Radio: {
            colorText: "#000"
          },
          Select: {
            colorBgContainer: "#fff",
            colorTextPlaceholder: "#000",
            colorText: "#000",
            optionActiveBg: "white",
            colorBgTextActive: "white",
            optionSelectedColor: "white"
          },
          Upload: {
            colorBorder: "#6A6A6A"
          },
          Button: {
            defaultActiveBorderColor: "#6A6A6A",
            defaultHoverBorderColor: "#6A6A6A",
            colorText: "#fff",
            defaultHoverColor: "#fff",
            defaultActiveColor: "#fff"
          }
        }
      }}>
      <StagingAuthProvider>
        <App />
      </StagingAuthProvider>
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
